import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { useAccount } from "wagmi"

type MutationFnParams = {
  recipient: string
  amount: bigint
}

type UseDepositBTCTransactionOptions = Omit<
  UseMutationOptions<string, Error, MutationFnParams>,
  "mutationKey" | "mutationFn"
>

export default function useSendBitcoin(
  options?: UseDepositBTCTransactionOptions,
) {
  const { connector, address } = useAccount()

  return useMutation({
    mutationKey: ["send-bitcoin"],
    mutationFn: async ({ recipient, amount }: MutationFnParams) => {
      if (!address) {
        throw new Error("Bitcoin account was not connected.")
      }

      if (!connector || !connector.getClient) {
        throw new Error("Connector was not defined.")
      }

      const client = await connector.getClient()
      // @ts-expect-error The Passport client has `sendBitcoin` function.
      if (typeof client.sendBitcoin !== "function") {
        throw new Error("Connector doesn't support sending Bitcoins.")
      }

      const satoshis = Number(amount)

      // @ts-expect-error We checked above if the client has the `sendBitcoin`
      // function.
      const txhash: string = await client.sendBitcoin(recipient, satoshis)
      return txhash
    },
    ...options,
  })
}
